// removed by extract-text-webpack-plugin
module.exports = {"menu__icon":"MobileMenu__menu__icon___13zFF","flower":"MobileMenu__flower___2yz_M","flower__petal__1":"MobileMenu__flower__petal__1___2n82r","flower__petal__2":"MobileMenu__flower__petal__2____YOFJ","flower__petal__3":"MobileMenu__flower__petal__3___3mH4d","flower__petal__4":"MobileMenu__flower__petal__4___2sKul","flower__petal__5":"MobileMenu__flower__petal__5___2SzzW","flower__petal__6":"MobileMenu__flower__petal__6___UefM4","unrotate__icon":"MobileMenu__unrotate__icon___eRy1L","rotate__icon":"MobileMenu__rotate__icon___NxVnL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileMenu/MobileMenu.scss
// module id = 79
// module chunks = 0